import { render, staticRenderFns } from "./WorkSearchPopComp2.vue?vue&type=template&id=5e5336a8&scoped=true"
import script from "./WorkSearchPopComp2.vue?vue&type=script&lang=js"
export * from "./WorkSearchPopComp2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5336a8",
  null
  
)

export default component.exports